// src/components/forms/fieldsConfig/demandePrixFields.js

// Champs pour la création d'une demande de prix
export const demandePrixCreationFields = [
  { 
    name: 'fournisseurId', 
    label: 'Fournisseur', 
    type: 'select', 
    required: true,
    options: [], // Rempli dynamiquement
    placeholder: 'Sélectionner un fournisseur',
    col: 12
  },
  { 
    name: 'dateLimiteReponse', 
    label: 'Date limite de réponse', 
    type: 'date', 
    required: true,
    helpText: 'Date limite pour recevoir les propositions de prix',
    col: 6
  },
  { 
    name: 'titre', 
    label: 'Titre de la demande', 
    type: 'text', 
    placeholder: 'Ex: Demande de prix pour installation électrique',
    col: 6
  },
  { 
    name: 'description', 
    label: 'Description', 
    type: 'textarea', 
    rows: 3,
    placeholder: 'Description détaillée de la demande...',
    col: 12
  },
  { 
    name: 'projet', 
    label: 'Projet concerné', 
    type: 'text', 
    placeholder: 'Nom du projet',
    col: 6
  },
  { 
    name: 'notes', 
    label: 'Notes internes', 
    type: 'textarea', 
    rows: 2,
    placeholder: 'Notes pour l\'équipe interne...',
    col: 12
  }
];

// Champs pour la mise à jour d'une demande de prix
export const demandePrixUpdateFields = [
  ...demandePrixCreationFields,
  { 
    name: 'statut', 
    label: 'Statut', 
    type: 'select', 
    required: true,
    options: [
      { value: 'brouillon', label: 'Brouillon' },
      { value: 'envoyée', label: 'Envoyée' },
      { value: 'en_attente', label: 'En attente' },
      { value: 'réponse_reçue', label: 'Réponse reçue' },
      { value: 'partiellement_utilisée', label: 'Partiellement utilisée' },
      { value: 'complètement_utilisée', label: 'Complètement utilisée' },
      { value: 'expirée', label: 'Expirée' },
      { value: 'annulée', label: 'Annulée' },
      { value: 'transformé_commande', label: 'Transformé en commande' }
    ],
    defaultValue: 'brouillon',
    col: 6
  }
];

// Champs pour ajouter une réponse fournisseur
export const demandePrixReponseFields = [
  { 
    name: 'ligneId', 
    label: 'Ligne concernée', 
    type: 'select', 
    required: true,
    options: [], // Rempli dynamiquement avec les lignes de la demande
    placeholder: 'Sélectionner une ligne'
  },
  { 
    name: 'prixPropose', 
    label: 'Prix proposé (HT)', 
    type: 'number', 
    required: true,
    min: 0,
    step: 0.01,
    placeholder: '0.00'
  },
  { 
    name: 'delaiLivraison', 
    label: 'Délai de livraison', 
    type: 'text', 
    placeholder: 'Ex: 15 jours, 1 mois...'
  },
  { 
    name: 'conditions', 
    label: 'Conditions spéciales', 
    type: 'textarea', 
    rows: 2,
    placeholder: 'Conditions de paiement, garanties...'
  }
];

// Fonction pour formater les données demande de prix
export const formatDemandePrixData = (formData) => {
  const formattedData = {
    fournisseurId: formData.fournisseurId,
    dateLimiteReponse: formData.dateLimiteReponse,
    titre: formData.titre?.trim(),
    description: formData.description?.trim(),
    projet: formData.projet?.trim(),
    notes: formData.notes?.trim()
  };

  // Si c'est une mise à jour, inclure le statut
  if (formData.statut) {
    formattedData.statut = formData.statut;
  }

  return formattedData;
};

// Fonction pour pré-remplir les données demande de prix
export const prepareDemandePrixFormData = (demandePrix) => {
  if (!demandePrix) return {};
  
  return {
    fournisseurId: demandePrix.fournisseurId?._id || demandePrix.fournisseurId || '',
    dateLimiteReponse: demandePrix.dateLimiteReponse 
      ? new Date(demandePrix.dateLimiteReponse).toISOString().split('T')[0] 
      : '',
    titre: demandePrix.titre || '',
    description: demandePrix.description || '',
    projet: demandePrix.projet || '',
    notes: demandePrix.notes || '',
    statut: demandePrix.statut || 'brouillon'
  };
};

// Fonction de validation
export const validateDemandePrixForm = (formData) => {
  const errors = {};
  
  if (!formData.fournisseurId) {
    errors.fournisseurId = 'Le fournisseur est obligatoire';
  }
  
  if (!formData.dateLimiteReponse) {
    errors.dateLimiteReponse = 'La date limite de réponse est obligatoire';
  } else {
    const limiteDate = new Date(formData.dateLimiteReponse);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (limiteDate < today) {
      errors.dateLimiteReponse = 'La date limite est dans le passé';
    }
  }
  
  return errors;
};

export default {
  creation: demandePrixCreationFields,
  update: demandePrixUpdateFields,
  reponse: demandePrixReponseFields,
  format: formatDemandePrixData,
  prepare: prepareDemandePrixFormData,
  validate: validateDemandePrixForm
};